import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import { LogOut } from "lucide-react";
import {
    Drawer,
    DrawerContent,
    DrawerHeader,
    DrawerTitle,
} from "@/components/ui/drawer";

export function MobileNavDrawer({
    isOpen,
    onClose,
    navItems,
    active,
    onLogout
}) {
    const navigate = useNavigate();

    const handleNavigation = (path) => {
        navigate(path);
        onClose();
    };

    const handleLogout = () => {
        onLogout();
        onClose();
    };

    // Handle drawer open state changes (receives boolean)
    const handleOpenChange = (open) => {
        if (!open) {
            onClose();
        }
    };

    return (
        <Drawer open={isOpen} onOpenChange={handleOpenChange}>
            <DrawerContent className="max-h-[85vh] flex flex-col">
                <DrawerHeader className="border-b border-slate-200 pb-4 flex-shrink-0">
                    <DrawerTitle className="text-lg font-semibold">Menu</DrawerTitle>
                </DrawerHeader>

                {/* Single scrollable section containing everything */}
                <div className="flex-1 overflow-y-auto">
                    <nav className="mobile-drawer-nav">
                        {navItems.map((item) => (
                            <div
                                key={item.id}
                                data-testid={`drawer-nav-${item.id}`}
                                className={`drawer-nav-item ${active === item.id ? 'active' : ''}`}
                                onClick={() => handleNavigation(item.path)}
                            >
                                <item.icon size={20} />
                                <span>{item.label}</span>
                            </div>
                        ))}

                        {/* Logout item - looking exactly like other items */}
                        <div
                            data-testid="drawer-nav-logout"
                            className="drawer-nav-item logout"
                            onClick={handleLogout}
                        >
                            <LogOut size={20} />
                            <span>Logout</span>
                        </div>
                    </nav>
                </div>
            </DrawerContent>
        </Drawer>
    );
}

MobileNavDrawer.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    navItems: PropTypes.array,
    active: PropTypes.string,
    onLogout: PropTypes.func
};
